import { render, staticRenderFns } from "./monthlyProductStatisticsDetail.vue?vue&type=template&id=9bd11f0a&scoped=true"
import script from "./monthlyProductStatisticsDetail.vue?vue&type=script&lang=js"
export * from "./monthlyProductStatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./monthlyProductStatisticsDetail.vue?vue&type=style&index=0&id=9bd11f0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd11f0a",
  null
  
)

export default component.exports